import { useAuthContext } from '../../../context/auth.context'
import { useRoleSysLmsPreset } from '../../../role/hook/role-sys'

export const READ_ONLY_ROLE = 'You can view the LMS presets but not change them. Creating or changing a preset needs the LMS preset update permission.'
export const READ_ONLY_IMPERSONATING = "You're signed in as someone else, so the LMS presets can be viewed but not changed. End the impersonation to make changes."

// Who may create or change an LMS preset: SYS_LMS_PRESET update (root has
// every system scope), and never from an impersonated session. The server
// answers 403 FORBIDDEN_SCOPE and IMPERSONATION_NOT_ALLOWED to the rest, so
// the UI offers no write it can't do (the alert routing page's rule).
export const usePresetAccess = () => {
  const { state } = useAuthContext()
  const role = useRoleSysLmsPreset()
  const impersonating = Boolean(state && state.jwtClaims && state.jwtClaims.impersonationEndsAt)
  const canEdit = Boolean(role.accessUpdate) && !impersonating
  const reason = canEdit ? null : impersonating ? READ_ONLY_IMPERSONATING : READ_ONLY_ROLE
  return { canEdit, impersonating, reason }
}
